import Splide from '@splidejs/splide';

export default () => {
  const relatedSliders = document.querySelectorAll('.related-posts-slider');

  if(!relatedSliders) return;

  relatedSliders.forEach(slider => {
    const categorySlider = slider.classList.contains('category-slider'),
          sliderID = slider.dataset.id;

    const relatedSlider = new Splide(slider, {
      perPage: 1,
      gap:'10px',
      perMove: 1,
      arrows: false,
      pagination: false,
      height:'450px',
      padding:{
        right:'55px',
      },
      mediaQuery: 'min',
      breakpoints: {
        576: {
          perPage: 2,
        },
        992: {
          perPage: 3,
        },
        1200: {
          perPage: 4,
          height:categorySlider ? '340px' : '510px',
          gap:'20px',
          padding:{
            right:'65px'
          },
        },
        1750: {
          perPage: 4,
          padding:{
            right:'240px'
          },
        }
      }
    });
  
    relatedSlider.mount();
  
    const sectionContainer = document.querySelector(`#related-posts-${sliderID}`),
          navigation = sectionContainer.querySelector('.related-slider-navigation');

    if(!navigation) return;        
      const btnNext = navigation.querySelector('.arrowNext'),
            btnPrev = navigation.querySelector('.arrowPrev');

    relatedSlider?.on( 'move', function () {
      const index = relatedSlider.index,
            container = document.querySelector(`#related-posts-${sliderID} .slider-container`),
            action = index ? 'add' : 'remove';

      container?.classList[action]('expanded');
    });

    btnNext?.addEventListener('click', e => relatedSlider.go('+1'));
    btnPrev?.addEventListener('click', e => relatedSlider.go('-1'));
  });
}